let origin = window.origin;
console.log(origin);
const WEB_BASE_URL = origin + "/api";

module.exports = { WEB_BASE_URL };
